// src/utils/currency.ts
// Utility for static CZK->EUR conversion at rate 25 CZK = 1 EUR
export const CZK_PER_EUR = 25;

export function czkToEur(amountCzk: number): number {
  return amountCzk / CZK_PER_EUR;
}

export function formatCzk(amount: number, locale: string = 'cs'): string {
  return new Intl.NumberFormat(localeMap(locale), { style: 'currency', currency: 'CZK', minimumFractionDigits: 0 }).format(amount);
}

export function formatEur(amount: number, locale: string = 'cs'): string {
  return new Intl.NumberFormat(localeMap(locale), { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(amount);
}

function localeMap(lang: string): string {
  const base = lang.slice(0,2);
  switch (base) {
    case 'cs': return 'cs-CZ';
    case 'de': return 'de-DE';
    case 'en': return 'en-GB';
    default: return 'en-GB';
  }
}

export function formatApproxEur(amountCzk: number, lang: string): string {
  const eur = czkToEur(amountCzk);
  return formatEur(eur, lang);
}

/**
 * Universal price formatter - displays price with correct currency symbol
 * and EUR conversion for non-Czech languages
 */
export function formatPrice(amountCzk: number, lang: string, showEur: boolean = true): string {
  const symbol = lang === 'cs' ? 'Kč' : 'CZK';
  const formatted = `${amountCzk.toLocaleString()} ${symbol}`;
  
  if (lang !== 'cs' && showEur) {
    return `${formatted} (${formatApproxEur(amountCzk, lang)})`;
  }
  return formatted;
}

/**
 * Format price for inline use (e.g., per night, per person)
 */
export function formatPricePerUnit(amountCzk: number, lang: string, unit: string): string {
  const symbol = lang === 'cs' ? 'Kč' : 'CZK';
  return `${amountCzk.toLocaleString()} ${symbol}/${unit}`;
}
